import { IRenderingCommonContext } from "@commonRendering/types";
import { BaseDynamicElementScriptRenderer } from "../../../shared/rendering/base-dynamic-element-script-renderer";
import { TruFormLocalScriptContentProviderOptions } from "../../../typings/local-script-content-provider";
import {
    TruFormWidgetScriptContentProvider
} from "../../../shared/rendering/local-script-content-providers/truform-widget-script-content-provider";
import { SiteDesignStylesService } from "../../../services/site-design-styles.service";

export class TruFormWidgetScriptRenderer extends BaseDynamicElementScriptRenderer {

    constructor(protected renderingCommonContext: IRenderingCommonContext) {
        super(
            "0.1",
            "pb-embed-truform-script",
            renderingCommonContext.data.truFormUrl,
            "-truform",
            new TruFormWidgetScriptContentProvider(renderingCommonContext.data.gdprInfo)
        );
    }

    public override renderLocal(element: HTMLElement): void {
        const script = this.createScriptElement(element);
        if (!script) {
            return;
        }

        const appDivElement = element.querySelector<HTMLElement>(".tru-forms-app-caller");

        const siteDesignStylesService = SiteDesignStylesService.createByDoc(this.renderingCommonContext.renderedDoc);
        const scriptContentProviderOptions: TruFormLocalScriptContentProviderOptions = {
            elementId: element.id,
            commonScriptId: this.commonScriptId,
            formId: appDivElement?.getAttribute("tru-forms-app-id") || "",
            excludeFromGdpr: appDivElement?.getAttribute("tru-forms-exclude-from-gdpr") === "true",
            styleOptions: {
                shouldInheritCommonStyles: appDivElement?.getAttribute("tru-forms-should-inherit-styles") === "true",
                styles: siteDesignStylesService.getStyles()
            }
        };
        script.textContent = this.scriptContentProvider?.getScriptTextContent(scriptContentProviderOptions);
        element.appendChild(script);
    }

}
